export const getAgencySignupErrorCode = state => state.agencySignup.errorCode;
export const getAgencySignupStatus = state => state.agencySignup.status;
export const getAgencySignupIsLoading = state => state.agencySignup.isLoading;
export const getAgencySignupEmailSent = state => state.agencySignup.emailSent;
export const getAgencyNameAvailable = state => state.agencySignup.nameAvailable;
